import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching user data
export const fetchUserData = createAsyncThunk("user/fetchUserData", async (_, { getState }) => {
  const state = getState();
  const token = state.auth.token;  // Retrieve token from state

  // console.log("token>>>>>>>>>>>>>", token);  // Debug: check the token value

  if (!token) {
    throw new Error("No token found");  // Handle case where token is null
  }

  const response = await axios.get( `${process.env.REACT_APP_API_URL}/me`, {
    headers: {
      Authorization: token,
        // Correctly include token in header
    },
  });

  return response.data;

});

const userSlice = createSlice({
  name: "user",
  initialState: {
    userId: null,
    name: "",
    email: "",
    status: "idle",
    error: null,
  },
  reducers: {
    // You can add synchronous actions here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userId = action.payload._id;
        state.name = action.payload.name;
        state.email = action.payload.email;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default userSlice.reducer;
